import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
	<div className="not-found-page">
		<div className="message fadeInLoadUp">
			<h1 className="not-found-title">404</h1>
			<h2 className="not-found-text">Sorry, page not found !</h2>
			<Link to="/" className="homepage-link">Go Back to Home Page</Link>
		</div>
	</div>
);
export default NotFound;


// WEBPACK FOOTER //
// ./src/components/pages/public-pages/NotFound.js